import {
  ScrollableComponent
} from "../chunks/chunk.7SUFJ5CO.js";
import "../chunks/chunk.M25GCR2X.js";
import "../chunks/chunk.D2XWPAUR.js";
import "../chunks/chunk.YAGRC5Z4.js";
import "../chunks/chunk.DLI4WUT3.js";
import "../chunks/chunk.TH3OKA3N.js";
import "../chunks/chunk.DJPU2C2P.js";
import "../chunks/chunk.NKMLXBZO.js";
import "../chunks/chunk.HUNECYG5.js";
import {
  conditionalRender
} from "../chunks/chunk.XNLGRHFL.js";
import "../chunks/chunk.B7B7E6VL.js";
import "../chunks/chunk.7YPNNGYZ.js";
import "../chunks/chunk.DBFD4ZAO.js";
import "../chunks/chunk.B7YNIICV.js";
import "../chunks/chunk.AZYLF2D7.js";
import "../chunks/chunk.CE3ZRZXS.js";
import "../chunks/chunk.KPYPODQD.js";
import "../chunks/chunk.CD3DSRSX.js";
import {
  animateTo,
  getAnimation,
  setDefaultAnimation,
  stopAnimations
} from "../chunks/chunk.PXGMVSIO.js";
import "../chunks/chunk.54YXW2TU.js";
import {
  emit,
  waitForEvent
} from "../chunks/chunk.HM4ZRC4T.js";
import "../chunks/chunk.ZX7YPA4S.js";
import {
  hasSlot
} from "../chunks/chunk.Z2CDDKXX.js";
import "../chunks/chunk.JFZ7XS7L.js";
import {
  watch
} from "../chunks/chunk.HBM5K2JV.js";
import {
  YotpoFooterAction
} from "../chunks/chunk.AREYZEAJ.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "../chunks/chunk.U4VUMZVF.js";

// src/components/modal/modal.ts
import { html } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/utilities/lock-scroll.ts
var locks = /* @__PURE__ */ new Set();
function lockBodyScrolling(lockingEl) {
  locks.add(lockingEl);
  document.body.classList.add("yotpo-scroll-lock");
}
function unlockBodyScrolling(lockingEl) {
  locks.delete(lockingEl);
  if (locks.size === 0) {
    document.body.classList.remove("yotpo-scroll-lock");
  }
}

// src/components/modal/modal.styles.ts
import { css } from "lit";
var modal_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

	:host {
		--width: 480px; /* 30rem */
		--height: auto;
		display: contents;
	}

	.modal {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: var(--yotpo-z-index-modal);
	}

	.modal--width-default:not(.modal--full-screen) .modal__panel {
		width: var(--width);
	}

	.modal--width-medium:not(.modal--full-screen) .modal__panel {
		width: 600px;
	}

	.modal--width-large:not(.modal--full-screen) .modal__panel {
		width: 800px;
	}

	.modal__panel {
		display: flex;
		flex-direction: column;
		z-index: 2;
		height: var(--height);
		min-width: 400px; /* 25rem */
		max-width: calc(100% - var(--yotpo-spacing-modal));
		max-height: calc(100% - var(--yotpo-spacing-modal));
		background-color: var(--yotpo-color-white);
		border-radius: var(--yotpo-border-radius-large);
		box-shadow: var(--yotpo-shadow-40);
	}

	::-moz-focus-inner {
		border: 0;
	}

	:focus {
		outline: none;
	}

	.footer_action_icon {
		height: 100%;
		vertical-align: text-top;
		display: inline-flex;
	}

	.action-icon {
		font-size: 16px;
		display: flex;
	}

	.modal__footer-main-action-button:focus,
	.modal__footer-secondary-action-button:focus,
	.modal__close yotpo-icon-button:focus {
		box-shadow: var(--yotpo-focus-global);
		border-radius: var(--yotpo-button-border-radius);
		transition: var(--yotpo-transition-medium) border-color, var(--yotpo-transition-medium) background-color,
			var(--yotpo-transition-medium) color, var(--yotpo-transition-medium) box-shadow;
	}

	.modal--open .modal__panel {
		display: flex;
		opacity: 1;
		transform: none;
	}

	.modal--full-screen .modal__panel {
		width: calc(100% - var(--yotpo-spacing-modal));
		height: calc(100% - var(--yotpo-spacing-modal));
	}

	.modal__header {
		flex: 0 0 auto;
		display: flex;
		justify-content: flex-end;
	}

	.modal__titles {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		padding: var(--yotpo-spacing-x-large) 0 var(--yotpo-spacing-x-large) var(--yotpo-spacing-xx-large);
		width: 100%;
	}

	.modal__subtitle {
		margin-top: var(--yotpo-spacing-small);
	}

	.modal__close {
		flex: 0 0 auto;
		align-items: center;
		padding: var(--yotpo-spacing-medium) var(--yotpo-spacing-medium) 0 0;
	}

	.modal__body {
		flex: 1 1 auto;
	}

	.modal__body-margins {
		padding: var(--yotpo-spacing-x-large) var(--yotpo-spacing-xx-large);
	}

	.modal__body-overflow-scroll {
		overflow: auto;
	}

	.modal__footer {
		flex: 0 0 auto;
		text-align: right;
		padding: var(--yotpo-spacing-x-large) var(--yotpo-spacing-xx-large);
		display: flex;
	}

	.modal__footer-main-action {
		max-width: 50%;
	}

	.modal__footer-main-action-only {
		width: 100%;
		max-width: 100%;
		justify-content: flex-end;
		display: flex;
	}

	.footer_main_action_label {
		display: contents;
	}

	.modal__footer-left-slot {
		flex: 1 1 auto;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.modal__footer-actions {
		flex: 0 0 auto;
		width: 45%;
		display: flex;
		justify-content: flex-end;
		margin-left: var(--yotpo-spacing-x-large);
	}

	.modal__footer-actions-no-slot {
		width: 100%;
		margin-left: 0;
	}

	.modal__footer-secondary-action {
		margin-right: var(--yotpo-spacing-medium);
		max-width: 50%;
	}

	.modal__overlay {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: var(--yotpo-overlay-background-color);
	}
`;

// src/components/modal/modal.ts
var YotpoModal = class extends ScrollableComponent {
  constructor() {
    super(...arguments);
    this.hasLeftFooterSlot = false;
    this.customEvents = [
      "yotpo-show" /* show */,
      "yotpo-hide" /* hide */,
      "yotpo-request-close" /* requestClose */,
      "yotpo-main-action" /* mainAction */,
      "yotpo-secondary-action" /* secondaryAction */,
      "yotpo-change" /* change */,
      "yotpo-scroll-end" /* scrollEnd */
    ];
    this.open = false;
    this.modalTitle = "";
    this.modalSubtitle = "";
    this.width = "default" /* default */;
    this.footerAction = "all" /* all */;
    this.footerType = "positive" /* positive */;
    this.dividerHeader = false;
    this.dividerFooter = false;
    this.bodyMargins = true;
    this.bodyOverflowScroll = true;
    this.hideCloseButton = false;
    this.disableClose = false;
    this.fullScreen = false;
    this.footerCheckboxLabel = "";
    this.mainActionLabel = "Save";
    this.mainActionPrefixIcon = "";
    this.mainActionSuffixIcon = "";
    this.secondaryActionLabel = "Cancel";
    this.secondaryActionPrefixIcon = "";
    this.secondaryActionSuffixIcon = "";
    this.mainActionLoading = false;
    this.secondaryActionLoading = false;
    this.mainActionDisabled = false;
    this.secondaryActionDisabled = false;
  }
  firstUpdated() {
    this.modal.hidden = !this.open;
    if (this.open)
      lockBodyScrolling(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    unlockBodyScrolling(this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleSlotChange();
  }
  handleSlotChange() {
    this.hasLeftFooterSlot = hasSlot(this, "footer");
  }
  async show() {
    if (this.open)
      return void 0;
    this.open = true;
    return waitForEvent(this, "yotpo-show" /* show */);
  }
  async hide() {
    if (!this.open)
      return void 0;
    this.open = false;
    return waitForEvent(this, "yotpo-hide" /* hide */);
  }
  requestClose(source) {
    const yotpoRequestClose = emit(this, "yotpo-request-close" /* requestClose */, {
      cancelable: true,
      detail: { source }
    });
    if (this.disableClose && (source === "keyboard" /* keyboard */ || source === "overlay" /* overlay */) || yotpoRequestClose.defaultPrevented) {
      const animation = getAnimation(this, "yotpo-modal.denyClose");
      animateTo(this.panel, animation.keyframes, animation.options);
      return;
    }
    this.hide();
  }
  disableFocusChildElements() {
    var _a, _b, _c;
    if (this.mainAction) {
      const mainActionButton = (_a = this.mainAction.shadowRoot) == null ? void 0 : _a.querySelector("button");
      if (mainActionButton)
        mainActionButton.tabIndex = -1;
    }
    if (this.secondaryAction) {
      const secondaryActionButton = (_b = this.secondaryAction.shadowRoot) == null ? void 0 : _b.querySelector("button");
      if (secondaryActionButton)
        secondaryActionButton.tabIndex = -1;
    }
    if (this.closeButton) {
      const closeButtonButton = (_c = this.closeButton.shadowRoot) == null ? void 0 : _c.querySelector("button");
      if (closeButtonButton)
        closeButtonButton.tabIndex = -1;
    }
  }
  handleKeyDown(event) {
    if (event.key === "Escape") {
      event.stopPropagation();
      this.requestClose("keyboard" /* keyboard */);
    }
    if (event.key === "Tab")
      this.disableFocusChildElements();
  }
  async handleOpenChange() {
    if (this.open) {
      this.originalTrigger = document.activeElement;
      lockBodyScrolling(this);
      await Promise.all([stopAnimations(this.modal), stopAnimations(this.overlay)]);
      this.modal.hidden = false;
      const panelAnimation = getAnimation(this, "yotpo-modal.show");
      const overlayAnimation = getAnimation(this, "yotpo-modal.overlay.show");
      await Promise.all([
        animateTo(this.panel, panelAnimation.keyframes, panelAnimation.options),
        animateTo(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
      ]);
      this.observeScrollableElement();
      emit(this, "yotpo-show" /* show */);
    } else {
      unlockBodyScrolling(this);
      await Promise.all([stopAnimations(this.modal), stopAnimations(this.overlay)]);
      const panelAnimation = getAnimation(this, "yotpo-modal.hide");
      const overlayAnimation = getAnimation(this, "yotpo-modal.overlay.hide");
      await Promise.all([
        animateTo(this.panel, panelAnimation.keyframes, panelAnimation.options),
        animateTo(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
      ]);
      this.modal.hidden = true;
      const trigger = this.originalTrigger;
      if (typeof (trigger == null ? void 0 : trigger.focus) === "function") {
        setTimeout(() => trigger.focus());
      }
      this.unobserveScrollableElement();
      emit(this, "yotpo-hide" /* hide */);
    }
  }
  handleCheckboxChange(event) {
    var _a;
    event.stopPropagation();
    emit(this, "yotpo-change" /* change */, { detail: { checked: (_a = this.checkbox) == null ? void 0 : _a.checked } });
  }
  get panelContent() {
    return html`
			<header part="header" data-cy="modal-header" class="modal__header">
				${this.modalTitle ? html` <div class="modal__titles yotpo-theme-light">
							<h3 part="title" class="modal__title" id="title">${this.modalTitle}</h3>
							${this.modalSubtitle ? html` <div
										part="subtitle"
										class="modal__subtitle yotpo-text-medium yotpo-text-secondary"
										id="subtitle"
								  >
										${this.modalSubtitle}
								  </div>` : ""}
					  </div>` : ""}
				<div class="modal__close">
					${conditionalRender(!this.hideCloseButton, html` <yotpo-icon-button
							name="close"
							data-cy="modal-close-button"
							aria-title="Close"
							tabindex="4"
							priority=${"tertiary" /* tertiary */}
							size=${"tiny" /* tiny */}
							color=${"dark" /* dark */}
							@click="${() => this.requestClose("close-button" /* closeButton */)}"
						>
						</yotpo-icon-button>`)}
				</div>
			</header>

			${this.dividerHeader ? html`<yotpo-divider></yotpo-divider>` : ""}

			<div
				part="body"
				yotpo-scrollable-element
				class=${classMap({
      modal__body: true,
      "yotpo-scrollbar": this.bodyOverflowScroll,
      "modal__body-margins": this.bodyMargins,
      "modal__body-overflow-scroll": this.bodyOverflowScroll
    })}
			>
				<div class="yotpo-theme-light">
					<div class="yotpo-text-medium yotpo-text-primary">
						<slot tabindex="1"></slot>
					</div>
				</div>
			</div>

			${this.dividerFooter ? html`<yotpo-divider></yotpo-divider>` : ""}
			${this.footerAction !== "none" /* none */ ? html` <footer part="footer" class="modal__footer">
						<div class="modal__footer-left-slot">
							${this.footerCheckboxLabel ? html`<yotpo-checkbox
										data-cy="modal-footer-checkbox"
										label=${this.footerCheckboxLabel}
										@yotpo-change=${(event) => this.handleCheckboxChange(event)}
								  ></yotpo-checkbox>` : html`${this.hasLeftFooterSlot ? html`<slot name="footer"></slot>` : ``}`}
						</div>
						<div
							class=${classMap({
      "modal__footer-actions": true,
      "modal__footer-actions-no-slot": !this.hasLeftFooterSlot && !this.footerCheckboxLabel
    })}
						>
							${this.footerAction === "all" /* all */ ? html` <div class="modal__footer-secondary-action">
										<yotpo-button
											class="modal__footer-secondary-action-button"
											data-cy="secondary-action-button"
											tabindex="3"
											aria-title=${this.secondaryActionLabel}
											priority=${"tertiary" /* tertiary */}
											color=${"dark" /* dark */}
											.loading=${this.secondaryActionLoading}
											.disabled=${this.secondaryActionDisabled}
											@click=${() => emit(this, "yotpo-secondary-action" /* secondaryAction */)}
										>
											<div class="footer_action_icon">
												${this.secondaryActionPrefixIcon ? html` <yotpo-icon
															class="action-icon"
															name="${this.secondaryActionPrefixIcon}"
															slot="prefix"
													  ></yotpo-icon>` : ""}
											</div>
											${this.secondaryActionLabel}
											<div class="footer_action_icon">
												${this.secondaryActionSuffixIcon ? html` <yotpo-icon
															class="action-icon"
															name="${this.secondaryActionSuffixIcon}"
															slot="prefix"
													  ></yotpo-icon>` : ""}
											</div>
										</yotpo-button>
								  </div>` : ""}
							<div
								class=${classMap({
      "modal__footer-main-action": true,
      "modal__footer-main-action-only": this.footerAction === "main" /* main */
    })}
							>
								<yotpo-button
									class="modal__footer-main-action-button"
									data-cy="main-action-button"
									tabindex="2"
									aria-title=${this.mainActionLabel}
									color=${this.footerType === "negative" /* negative */ ? "destructive" /* destructive */ : this.footerType === "premium" /* premium */ ? "premium" /* premium */ : "brand" /* brand */}
									.loading=${this.mainActionLoading}
									.disabled=${this.mainActionDisabled}
									@click=${() => emit(this, "yotpo-main-action" /* mainAction */)}
								>
									<div class="footer_action_icon">
										${this.mainActionPrefixIcon ? html` <yotpo-icon
													class="action-icon"
													name="${this.mainActionPrefixIcon}"
													slot="prefix"
											  ></yotpo-icon>` : ""}
									</div>
									${this.mainActionLabel}
									<div class="footer_action_icon">
										${this.mainActionSuffixIcon ? html` <yotpo-icon
													class="action-icon"
													name="${this.mainActionSuffixIcon}"
													slot="prefix"
											  ></yotpo-icon>` : ""}
									</div>
								</yotpo-button>
							</div>
						</div>
				  </footer>` : ""}
		`;
  }
  render() {
    return html`
			<div
				part="base"
				data-cy="modal-base"
				class=${classMap({
      modal: true,
      "modal--open": this.open,
      "modal--full-screen": this.fullScreen,
      "modal--width-default": this.width === "default" /* default */,
      "modal--width-medium": this.width === "medium" /* medium */,
      "modal--width-large": this.width === "large" /* large */
    })}
				@keydown=${this.handleKeyDown}
			>
				<div
					part="overlay"
					class="modal__overlay"
					@click=${() => this.requestClose("overlay" /* overlay */)}
					tabindex="-1"
				></div>

				<div
					part="panel"
					class="modal__panel"
					role="modal"
					aria-modal="true"
					aria-hidden=${this.open ? "false" : "true"}
				>
					${conditionalRender(this.open, this.panelContent)}
				</div>
			</div>
		`;
  }
};
YotpoModal.styles = modal_styles_default;
__decorateClass([
  state()
], YotpoModal.prototype, "hasLeftFooterSlot", 2);
__decorateClass([
  query(".modal")
], YotpoModal.prototype, "modal", 2);
__decorateClass([
  query(".modal__panel")
], YotpoModal.prototype, "panel", 2);
__decorateClass([
  query(".modal__overlay")
], YotpoModal.prototype, "overlay", 2);
__decorateClass([
  query("yotpo-checkbox")
], YotpoModal.prototype, "checkbox", 2);
__decorateClass([
  query(".modal__footer-main-action-button")
], YotpoModal.prototype, "mainAction", 2);
__decorateClass([
  query(".modal__footer-secondary-action-button")
], YotpoModal.prototype, "secondaryAction", 2);
__decorateClass([
  query(".modal__close yotpo-icon-button")
], YotpoModal.prototype, "closeButton", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "open", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "modalTitle", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "modalSubtitle", 2);
__decorateClass([
  property({ type: YotpoFooterAction, reflect: true })
], YotpoModal.prototype, "width", 2);
__decorateClass([
  property({ type: YotpoFooterAction, reflect: true })
], YotpoModal.prototype, "footerAction", 2);
__decorateClass([
  property({ type: YotpoFooterAction, reflect: true })
], YotpoModal.prototype, "footerType", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "dividerHeader", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "dividerFooter", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "bodyMargins", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "bodyOverflowScroll", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "hideCloseButton", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "disableClose", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoModal.prototype, "fullScreen", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "footerCheckboxLabel", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "mainActionLabel", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "mainActionPrefixIcon", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "mainActionSuffixIcon", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "secondaryActionLabel", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "secondaryActionPrefixIcon", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "secondaryActionSuffixIcon", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "mainActionLoading", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "secondaryActionLoading", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "mainActionDisabled", 2);
__decorateClass([
  property({ reflect: true })
], YotpoModal.prototype, "secondaryActionDisabled", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], YotpoModal.prototype, "handleOpenChange", 1);
YotpoModal = __decorateClass([
  customElement("yotpo-modal")
], YotpoModal);
setDefaultAnimation("yotpo-modal.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.8)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: { duration: 250, easing: "ease" }
});
setDefaultAnimation("yotpo-modal.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.8)" }
  ],
  options: { duration: 250, easing: "ease" }
});
setDefaultAnimation("yotpo-modal.denyClose", {
  keyframes: [{ transform: "scale(1)" }, { transform: "scale(1.02)" }, { transform: "scale(1)" }],
  options: { duration: 250 }
});
setDefaultAnimation("yotpo-modal.overlay.show", {
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  options: { duration: 250 }
});
setDefaultAnimation("yotpo-modal.overlay.hide", {
  keyframes: [{ opacity: 1 }, { opacity: 0 }],
  options: { duration: 250 }
});
export {
  YotpoModal
};
